<template>
  <div>

    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder="Pesquisar por CPF, Renavam ou Protocolo de encaminhamento para indicacao"
        >
        <SearchIcon @click="find()" class="icon icon-within" />
      </div>

      <button
        class="col-md-2 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <ChevronDownIcon class="fa-angle-right" :class="{ 'rotate-90': showFilter }" />
      </button>

      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query"
          @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="badgeFilters"
        />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label>Contas</label>
          <Select2 :options="filterAccount" v-model="query.accountId" title-load="Carregando contas..."/>
        </div>

        <div class="col-md-4">
          <label>Status</label>
          <Select2 :options="filterStatus" v-model="query.driverIndicationStatusId"/>
        </div>

        <div class="col-md-4">
          <label>Atualizado por</label>
          <Select2
            :options="filterUpdatedBy"
            v-model="query.updatedBy"
            title-load="Carregando usuarios..."
            :disabled="!filterUpdatedBy"
          />
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4">
          <label for="type-period">Tipo do periodo</label>
          <select v-model="query.periodType" id="type-period" class="browser-default custom-select">
            <option value="updated_at">Data de atualizacao</option>
            <option value="occurred_at">Data da infracao</option>
            <option value="created_at">Data de criacao</option>
            <option value="indication_deadline">Prazo de indicacao</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>
    </template>
    <hr/>

    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <strong class="mr-3">
          {{ infoTotalModels }}
        </strong>

        <button
          class="btn btn-outline ml-3 mb-1"
          v-if="driverIndications.length > 0"
          @click="changeCheckAll"
          :class="{ 'btn-outline-active': checkAll}"
        >
          Selecionar todos ({{ meta.totalCount || 'Calculando' }})
        </button>

        <button
          class="btn btn-primary ml-3 mb-1"
          @click="createReport"
          :disabled="disabledReport"
        >
          Baixar relatório
        </button>

        <div class="float-right" style="display: inline-flex;align-items: center;">
          <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
          <select v-model="order" @change="find()" class="browser-default custom-select">
            <option :value="['updated_at', 'desc']">Data de atualizacao</option>
            <option :value="['created_at', 'desc']">Data de criacao</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-sm-12 mt-2">
        <table class="table table-borderless table-dfe">
          <thead>
            <tr>
              <th>
                <BkpsCheckBox :value="checkAllRow" @input="changeCheckAllRow" />
              </th>
              <th>ID</th>
              <th>AIT</th>
              <th>Placa</th>
              <th>Renavam</th>
              <th>Conta</th>
              <th>Data da Infracao</th>
              <th>Prazo de Indicacao</th>
              <th>CPF</th>
              <th>Motorista</th>
              <th>Status</th>
              <th>Protocolo Encaminhamento para Indicacao</th>
              <th>Atualizado por</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="indication in driverIndications" :key="indication.id">
              <td>
                <BkpsCheckBox v-model="indication.checked" @input="changeCheckRow" />
              </td>
              <td>{{ indication.id }}</td>
              <td>{{ indication.ticket && indication.ticket.ait || '-' }}</td>
              <td>{{ indication.ticket && indication.ticket.plate || '-' }}</td>
              <td>{{ indication.ticket && indication.ticket.renavam || '-' }}</td>
              <td>{{ getAccountName(indication) }}</td>
              <td>{{ indication.ticket && indication.ticket.occurredAt | datetime }}</td>
              <td>{{ indication.ticket && indication.ticket.indicationDeadline | datetime }}</td>
              <td>{{ indication.ticket && indication.ticket.cpf || '-' }}</td>
              <td>{{ indication.driver && indication.driver.name || '-' }}</td>
              <td class="nowrap">
                {{ getStatusName(indication) }}
                <InfoIcon
                  size="1.5x"
                  v-tooltip="showDriverIndicationStatus(indication.driverIndicationStatusId)"
                />
              </td>
              <td>{{ indication.protocol || '-' }}</td>
              <td>{{ indication.updatedBy || '-' }}</td>
              <td>{{ indication.createdAt | datetime }}</td>
              <td>{{ indication.updatedAt | datetime }}</td>
              <td>
                <button @click="showIndicationDetails(indication)" class="btn btn-primary btn-sm">
                  Detalhes
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12 my-1">
        <Pagination
          v-model="meta.currentPage"
          :total-count="meta.totalCount"
          :total-pages="meta.totalPages"
          @pagination="pagination"
        />
      </div>
    </div>

    <!-- Show Modal -->
    <Show
      v-if="currentIndication"
      v-model="showModal"
      :indication="currentIndication"
      :driverIndicationStatuses="driverIndicationStatuses"
      @close="onModalClose"
      @saved="onIndicationSaved"
    />
  </div>
</template>

<script>
import { SearchIcon, ChevronDownIcon, InfoIcon } from 'vue-feather-icons'
import BadgeFilters from '@/components/shares/BadgeFilters'
import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
import CheckedModels from '@/mixins/CheckedModels'
import GlobalLoading from '@/mixins/GlobalLoading'
import ModelMapper from '@/mixins/ModelMapper'
import Pagination from '@/components/shares/specialTag/Pagination'
import Select2 from '@/components/shares/Select2'
import { Filter } from '@/models/filter'
import handleSearchable from '@/models/handleSearchable'
import Show from './Show'

export default {
  name: 'AdminDriverIndicationsIndex',
  components: {
    BadgeFilters,
    BkpsCheckBox,
    ChevronDownIcon,
    InfoIcon,
    Pagination,
    SearchIcon,
    Select2,
    Show
  },
  mixins: [CheckedModels, GlobalLoading, ModelMapper],
  superMethods: {
    buildParams: ModelMapper.methods.buildParams
  },
  inject: ['allAccounts', 'buildFilterAccount', 'getAccountName'],
  data: () => ({
    currentIndication: null,
    filterAccount: null,
    filterUpdatedBy: null,
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    filterStatus: null,
    driverIndicationStatuses: [],
    nameModel: 'DriverIndication',
    reportLoading: false,
    reportRequested: false,
    showModal: false,
  }),
  computed: {
    badgeFilters() {
      return [
        this.filterAccount,
        this.filterUpdatedBy,
        this.filterEndDate,
        this.filterStartDate,
        this.filterStatus
      ]
    },
    driverIndications() {
      return this.getModels || []
    },
    disabledReport() {
      return this.reportLoading || this.reportRequested || !this.driverIndications.some(i => i.checked)
    }
  },
  created() {
    this.addOrderBy('updatedAt')
    this.$set(this.query, 'periodType', 'updated_at')
    this.methods = ['driver', 'driver_indication_status']

    this.defaultModelSetting.updateQueryURL = true
    this.asyncTemplateSelect({
      byURL: true,
      pagination: true
    })

    this.filterAccount = this.buildFilterAccount(this.allAccounts.data)
    this.loadFilterUsers()
    this.loadDriverIndicationStatuses()
  },
  methods: {
    buildParams(pagination) {
      if (this.query.generic)
        this.query.generic = handleSearchable(this.query.generic)

      return this.$options.superMethods.buildParams.call(this, pagination)
    },
    buildPath() {
      return 'admin/maestro/driver_indications'
    },
    changeCheckAll() {
      this.releaseReport()
      this.changeCheck({ checkAll: !this.checkAll, sources: this.driverIndications })
    },
    changeCheckAllRow(value) {
      this.releaseReport()
      this.changeCheck({ checkAllRow: value, sources: this.driverIndications })
    },
    changeCheckRow() {
      this.releaseReport()
      this.changeCheck({ sources: this.driverIndications })
    },
    createReport() {
      if (this.disabledReport)
        return

      let params
      let amount

      if (this.checkAll) {
        params = this.buildParams()
        amount = this.meta.totalCount
      } else {
        const ids = this.driverIndications.filter(i => i.checked).map(i => i.id)
        params = { q: { id: ids } }
        amount = ids.length
      }

      if (!confirm(`Exportar ${amount} registro(s) de Indicacao de Condutores.\nTem certeza?`))
        return

      this.reportLoading = true
      this.openGlobalLoad()
      this.axios.get('admin/maestro/driver_indications/report', { params })
        .then(response => {
          if (response.data) {
            this.$parse.downloadByLink(response.data)
          } else {
            this.reportRequested = true
            this.$notify.add(response.meta.notice)
          }
        })
        .catch(e => this.$notify.addError(e))
        .finally(() => {
          this.reportLoading = false
          this.closeGlobalLoad()
        })
    },
    releaseReport() {
      this.reportRequested = false
    },
    find() {
      this.releaseReport()
      this.asyncTemplateSelect()
    },
    showIndicationDetails(indication) {
      this.currentIndication = indication
      this.showModal = true
    },
    onModalClose() {
      this.currentIndication = null
    },
    onIndicationSaved() {
      this.showModal = false
      this.currentIndication = null
      this.find()
    },
    loadFilterUsers() {
      this.axios.get('admin/users', {
        params: { per_page: 1000 }
      })
        .then(response => {
          if (response && response.data && response.data.length > 0) {
            this.filterUpdatedBy = new Filter({
              key: 'updatedBy',
              label: 'Atualizado por',
              table: response.data.map(u => [u.email, u.email])
            })
          }
        })
        .catch(e => this.$notify.addError(e))
    },
    loadDriverIndicationStatuses() {
      const key = 'admin/driverIndicationStatuses'
      const data = this.$ls.get(key)
      if (data) {
        this.driverIndicationStatuses = data
        this.buildFilterStatus(data)
        return
      }

      return this.axios.get('admin/maestro/driver_indication_statuses?meta=false&per_page=1000')
        .then(response => {
          this.driverIndicationStatuses = response.data
          this.buildFilterStatus(response.data)
        })
        .catch(e => this.notify.addError(e))
        .finally(() => this.$ls.set(key, this.driverIndicationStatuses, { minutes: 1 }))
    },
    buildFilterStatus(driverIndicationStatuses) {
      this.filterStatus = new Filter({
        key: 'driverIndicationStatusId',
        label: 'Status',
        table: driverIndicationStatuses.map(status => [`${status.name} (${status.code})`, status.id])
      })
    },
    getStatusName(indication) {
      if (indication.driver_indication_status_id && this.driverIndicationStatuses.length > 0) {
        const status = this.driverIndicationStatuses.find(s => s.id === indication.driver_indication_status_id)
        return status ? status.name : indication.driver_indication_status_id
      }
      return '-'
    },
    getStatusById(statusId) {
      if (statusId && this.driverIndicationStatuses.length > 0) {
        return this.driverIndicationStatuses.find(s => s.id === statusId)
      }
      return null
    },
    showDriverIndicationStatus(driverIndicationStatusId) {
      const driverIndicationStatus = this.driverIndicationStatuses.find(s => s.id === driverIndicationStatusId)
      if (!driverIndicationStatus) return '-'
      return [
        `code="${driverIndicationStatus.code}"`,
        `name="${driverIndicationStatus.name}"`,
        `description="${driverIndicationStatus.description}"`,
        `friendlyName="${driverIndicationStatus.friendlyName}"`,
        `friendlyDescription="${driverIndicationStatus.friendlyDescription}"`
      ].join(', ')
    }
  },
  watch: {
    allAccounts: {
      deep: true,
      handler(value) {
        this.filterAccount = this.buildFilterAccount(value.data)
      }
    },
    driverIndications(newValue, oldValue) {
      if (newValue !== oldValue)
        this.changeCheck({ checkAllRow: false })
    }
  }
}
</script>

<style scoped>
</style>
